const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const SESSION_KEY = "cn_dashboard_session";

export function getSessionToken() {
  return localStorage.getItem(SESSION_KEY);
}

export function setSessionToken(token) {
  localStorage.setItem(SESSION_KEY, token);
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}

async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  let body = null;
  try {
    body = await res.json();
  } catch (e) {
    // no body / non-JSON response
  }
  if (!res.ok) {
    const message = (body && body.detail) || `Request failed (${res.status})`;
    throw new Error(message);
  }
  return body;
}

export function requestMagicLink(email) {
  return apiFetch("/api/auth/request-link", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

export async function verifyMagicLink(token) {
  const data = await apiFetch("/api/auth/verify", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
  setSessionToken(data.session_token);
  return data.client;
}

export function fetchDashboard() {
  const token = getSessionToken();
  return apiFetch("/api/dashboard/me", {
    headers: { Authorization: `Bearer ${token}` },
  });
}
